import React, { createContext, useReducer } from 'react';

import type { CustomizationAction } from './actions';
import { customizationReducer } from './customizationReducer';
import {
  createInitialState,
  type CustomizationState,
  type TemplateIdentity,
} from './customizationState';

export const CustomizationStateContext =
  createContext<CustomizationState | null>(null);

export const CustomizationDispatchContext =
  createContext<React.Dispatch<CustomizationAction> | null>(null);

type Props = {
  identity: TemplateIdentity;
  children: React.ReactNode;
};

export function TemplateCustomizationProvider({ identity, children }: Props) {
  const [state, dispatch] = useReducer(
    customizationReducer,
    identity,
    createInitialState
  );

  const hasIdentityChanged =
    state.templateId !== identity.templateId ||
    state.channelId !== identity.channelId;

  if (hasIdentityChanged) {
    dispatch({ type: 'IDENTITY_CHANGED', identity });
  }

  return (
    <CustomizationDispatchContext.Provider value={dispatch}>
      <CustomizationStateContext.Provider value={state}>
        {children}
      </CustomizationStateContext.Provider>
    </CustomizationDispatchContext.Provider>
  );
}
